import React from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
	nextBtn: {
		position: "absolute",
		bottom: "100px",
        zIndex: '2',
	}
}))

const NextBtn = ({ isNextVisible, title }) => {
    const theme = useTheme()
	const classes = useStyles()
	return <div className={classes.nextBtn}>{isNextVisible ? <button>{title}</button> : null}</div>
}

export default NextBtn
